import { DriveStep } from 'driver.js';
import type { TFunction } from 'i18next';

export const createPracticeTourSteps = (t: TFunction): DriveStep[] => [
  {
    element: '[data-tour="practice-timer"]',
    popover: {
      title: t('onboarding.practice.timer_title', 'Таймер'),
      description: t(
        'onboarding.practice.timer_desc',
        'Отсчёт времени выступления. Укладывайтесь в тайминг.',
      ),
    },
  },
  {
    element: '[data-tour="practice-waveform"]',
    popover: {
      title: t('onboarding.practice.waveform_title', 'Микрофон'),
      description: t(
        'onboarding.practice.waveform_desc',
        'Визуализация активности микрофона во время записи.',
      ),
    },
  },
  {
    element: '[data-tour="practice-start"]',
    popover: {
      title: t('onboarding.practice.start_title', 'Запись'),
      description: t(
        'onboarding.practice.start_desc',
        'Нажмите «Начать» и читайте текст под слайды. Запись будет проанализирована автоматически.',
      ),
    },
  },
  {
    element: '[data-tour="practice-slides"]',
    popover: {
      title: t('onboarding.practice.slides_title', 'Навигация по слайдам'),
      description: t(
        'onboarding.practice.slides_desc',
        'Переключайте слайды стрелками или кликом. Синхронизируйтесь с презентацией.',
      ),
    },
  },
  {
    element: document.body,
    popover: {
      title: t('onboarding.practice.done_title', 'Тур завершён!'),
      description: t(
        'onboarding.practice.done_desc',
        'Вы познакомились со всем функционалом SpeechAI. Записывайте, получайте анализ, улучшайтесь!',
      ),
    },
  },
];
